import api from '../api';

import { ParamsDataCustomerForEdit } from 'utils/typeServices';

type ParamsReponse = {
    Data: ParamsDataCustomerForEdit;
}

export const GetCustomerForEdit = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<ParamsReponse>('v1/Cliente/GetCustomerForEdit', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
